import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/vintage-scrapbook/components/VintageScrapbookViewer.tsx");
